var RADIUS = 6371

var toRad = function (n) {
  return (n * Math.PI) / 180
}

var getDistance = function (from, to) {
  let fromLat = from.lat
  let fromLon = from.lng
  let toLat = to.lat
  let toLon = to.lng

  let dLat = toRad(toLat - fromLat)
  let dLon = toRad(toLon - fromLon)
  fromLat = toRad(fromLat)
  toLat = toRad(toLat)

  const a = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(fromLat) * Math.cos(toLat)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return RADIUS * c
}

module.exports = function (from, to) {
  return getDistance(from, to)
}
